const CHUNK_ERROR_RE =
  /Failed to load chunk|ChunkLoadError|Loading chunk \S+ failed|error loading dynamically imported module|Importing a module script failed/i;

const RELOAD_FLAG = 'tabootv_chunk_reload_at';
const RELOAD_COOLDOWN_MS = 60_000;

export function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_ERROR_RE.test(error.message);
}

/**
 * Chunk-load failures are almost always transient: a deploy pruned the old
 * build's chunks or the origin returned a one-off 5xx while serving
 * /_next/static. A full reload fetches fresh HTML with fresh chunk URLs and
 * recovers without user action. The sessionStorage timestamp caps this at one
 * auto-reload per cooldown window so a genuinely broken asset can't loop.
 *
 * Returns true when a reload was triggered — callers should skip error
 * reporting in that case (the recovery, not the transient, is the norm).
 */
export function attemptChunkReload(error: unknown): boolean {
  if (!isChunkLoadError(error)) return false;
  if (typeof window === 'undefined') return false;
  try {
    const lastReload = Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0);
    if (Date.now() - lastReload < RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  } catch {
    // sessionStorage unavailable (private mode edge cases): don't risk a loop.
    return false;
  }
  window.location.reload();
  return true;
}
